import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Select from "react-select";

import classes from "./styles.module.css";
import {
    Stack,
    Box,
    Text,
    VStack,
    HStack,
    Center,
    Badge,
  } from '@chakra-ui/react';
import ReactLoading from "react-loading";
import AuthService from "../../../services/auth.service";
import APIConfig from "../../../api/APIConfig";


function ListLaporanPeserta() {
    const [listlaporan, setListLaporan] = useState([]);
    const { id } = useParams();
    const { idMentor } = useParams();
    const { idMitra } = useParams();
    const [spinner, setSpinner] = useState(false);
    const optionKategori = [
        { value: 0, label: "-- Pilih Bulan --" },
        { value: 1, label: "Januari" },
        { value: 2, label: "Februari" },
        { value: 3, label: "Maret" },
        { value: 4, label: "April" },
        { value: 5, label: "Mei" },
        { value: 6, label: "Juni" },
        { value: 7, label: "Juli" },
        { value: 8, label: "Agustus" },
        { value: 9, label: "September" },
        { value: 10, label: "Oktober" },
        { value: 11, label: "November" },
        { value: 12, label: "Desember" },
    ]
    

    useEffect(() => {
        const user = AuthService.getCurrentUser();
        console.log(user)
        getListLaporan(id);
    }, [])

    const getListLaporan = async(id) => {
        setSpinner(true);
        const response = await APIConfig.get(`/v1/list-laporan/${id}`);
        const data = await response.data
        setListLaporan(data);
        setSpinner(false);
    };

    
    const [selectedValue, setSelectedValue] = useState(0);
    const handleSearchKategori = (e) => {
        setSelectedValue(e.value);
    };

    const matcher = (data) => {
        console.log(selectedValue);
        console.log(data.bulan);
        if (selectedValue === 0) return true;
        else if (selectedValue === 1) {
            if (data.bulan === 1) return true;
        } else if (selectedValue === 2) {
            if (data.bulan === 2) return true;
        } else if (selectedValue === 3) {
            if (data.bulan === 3) return true;
        } else if (selectedValue === 4) {
            if (data.bulan === 4) return true;
        } else if (selectedValue === 5) {
            if (data.bulan === 5) return true;
        } else if (selectedValue === 6) {
            if (data.bulan === 6) return true;
        } else if (selectedValue === 7) {
            if (data.bulan === 7) return true;
        } else if (selectedValue === 8) {
            if (data.bulan === 8) return true;
        } else if (selectedValue === 9) {
            if (data.bulan === 9) return true;
        } else if (selectedValue === 10) {
            if (data.bulan === 10) return true;
        } else if (selectedValue === 11) {
            if (data.bulan === 11) return true;
        } else if (selectedValue === 12) {
            if (data.bulan === 12) return true;
        }
        return false;
    };
    let data = listlaporan;
    data = data.filter((i) => matcher(i));  
    console.log(data.length);

    if (spinner){
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }
   
    return(
        <Center py={6}>
        <VStack align='stretch' justifyItems='left' fontFamily={'Inter'}>
            <Text
                pt={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}
                fontFamily={'Inter'}>
                Lihat Laporan Peserta
            </Text>
            <HStack color={'gray.500'} pb={10}>
                <Link to={`/mitra/profile/mentor/list-mentor/${idMitra}`}> Manajemen Mentor</Link>
                <p> / </p>
                <Link to={`/mitra/profile/mentor/list-mentee/${idMentor}/${idMitra}`} >Lihat Kinerja</Link>
                <p> / </p>
                <Link to="">Lihat Laporan</Link>
            </HStack>
            <HStack pr={10}  justifyContent={"space-between"}>
                    <Select
                        borderRadius="20%"
                        fontSize='10px'
                        pt={3}
                        pb={3}
                        border='1px solid #F5F5F5'
                        width='15%'
                        height='40px' 
                        id='kategori' 
                        options={optionKategori}
                        onChange={handleSearchKategori}
                        value={optionKategori.find((obj) => obj.value === selectedValue)}
                        placeholder="--Pilih Bulan--" />
                </HStack>
                <VStack pt={4} ></VStack>

            {data.length > 0 ?
            <div>
            {data.map((data) => (
                <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                rounded={'2xl'}
                p={6}
                overflow={'hidden'}>
                <VStack align='stretch' justifyItems='left' spacing={4}>
                    <Stack justifyContent='left'  spacing={2} align='left'>
                        <HStack justifyContent='space-between' direction='row' spacing={4} align='center'>
                            <VStack align='left'>
                            <p style={{'fontWeight':'bold'}}>{data.namaPeserta}</p> 
                            {data.bulan === 1 ? (
                                        <p style={{'color':'darkgray', 'font-size': '14px','font-weight': '400'}} className={classes.p}>Januari, Minggu ke-{data.minggu}</p> 
                                    ) : (
                                        data.bulan === 2 ? (
                                        <p style={{'color':'darkgray', 'font-size': '14px','font-weight': '400'}} className={classes.p}>Februari, Minggu ke-{data.minggu}</p> 
                                    ) : (
                                        data.bulan === 3 ? (
                                        <p style={{'color':'darkgray', 'font-size': '14px','font-weight': '400'}} className={classes.p}>Maret, Minggu ke-{data.minggu}</p> 
                                    ) : (
                                        data.bulan === 4 ? (
                                        <p style={{'color':'darkgray', 'font-size': '14px','font-weight': '400'}} className={classes.p}>April, Minggu ke-{data.minggu}</p>
                                    ) : (
                                        data.bulan === 5 ? (
                                        <p  style={{'color':'darkgray', 'font-size': '14px','font-weight': '400'}} className={classes.p}>Mei, Minggu ke-{data.minggu}</p>
                                    ) : (
                                        data.bulan === 6 ? (
                                        <p style={{'color':'darkgray', 'font-size': '14px','font-weight': '400'}} className={classes.p}>Juni, Minggu ke-{data.minggu}</p>
                                    ) : (
                                        data.bulan === 7 ? (
                                        <p style={{'color':'darkgray', 'font-size': '14px','font-weight': '400'}} className={classes.p}>Juli, Minggu ke-{data.minggu}</p>
                                    ) : (
                                        data.bulan === 8 ?(
                                        <p style={{'color':'darkgray', 'font-size': '14px','font-weight': '400'}} className={classes.p}>Agustus, Minggu ke-{data.minggu}</p>
                                        )
                                    
                                    :
                                    (
                                        data.bulan === 9 ?(
                                        <p style={{'color':'darkgray', 'font-size': '14px','font-weight': '400'}} className={classes.p}>September, Minggu ke-{data.minggu}</p>
                                        )
                                    
                                    :
                                    (
                                        data.bulan === 10 ?(
                                        <p style={{'color':'darkgray', 'font-size': '14px','font-weight': '400'}} className={classes.p}>Oktober, Minggu ke-{data.minggu}</p>
                                        )
                                    
                                    :
                                    (
                                        data.bulan === 11 ?(
                                        <p  style={{'color':'darkgray', 'font-size': '14px','font-weight': '400'}} className={classes.p}>November, Minggu ke-{data.minggu}</p>
                                        )
                                    
                                    :
                                    (
                                        (
                                        <p style={{'color':'darkgray', 'font-size': '14px','font-weight': '400'}} className={classes.p}>Desember, Minggu ke-{data.minggu}</p>
                                        )
                            
                                
                                )))))))))))}
                            </VStack>
                            
                            <VStack align='right' spacing={2}>
                                <div align='right'>
                                <Badge p={2} colorScheme='purple' fontSize='12px' align='right'>{data.status}</Badge>
                                </div>
                                <div align='right'>
                                <p style={{'fontSize':'12px', 'color':'GrayText'}}>{data.waktuPost}</p>
                                </div>
                            </VStack>
                        </HStack> 
                    </Stack>
                    <hr>
                    </hr>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Kegiatan</h3>
                        <p className={classes.p}>{data.namaKegiatan}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Topik</h3>
                        <p className={classes.p}>{data.topik}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Laporan</h3>
                        <p className={classes.p}>{data.isiLaporan}</p>
                    </VStack>
                    {data.feedback === null ? (
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Feedback</h3>
                        <p  style={{'color':'red', 'font-size': '14px','font-weight': '600'}} >feedback belum diberikan</p>
                    </VStack>
                    )
                    :
                    (
                        <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Feedback</h3>
                        <p  style={{'color':'green', 'font-size': '14px','font-weight': '600'}} >{data.feedback}</p>
                    </VStack>
                    )}
                    </VStack> 
                </Box>
                ))}
                </div>
                :
                <Text fontSize={"large"} fontWeight={'600'}>Tidak ada Laporan yang diberikan oleh peserta magang</Text>
                }
                
        </VStack>
        </Center>
    );
}

export default ListLaporanPeserta;

